import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import tiktokVerification from "./assets/files/tiktokIlcSDQkREl9rjxBS0GR6Ay0Bwntkvxui.txt";

const TermsScreen = () => {
  const [verificationContent, setVerificationContent] = useState("");

  useEffect(() => {
    const loadVerificationFile = async () => {
      try {
        const response = await fetch(tiktokVerification);
        const content = await response.text();
        setVerificationContent(content);
      } catch (error) {
        console.error("Lỗi khi đọc file:", error);
      }
    };

    loadVerificationFile();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100">
      <Helmet>
        <title>Điều Khoản Dịch Vụ | AutoWork</title>
        <meta
          name="description"
          content="Điều khoản dịch vụ AutoWork quy định trách nhiệm, quyền và nghĩa vụ khi sử dụng nền tảng AI tự động hóa nội dung."
        />
        <link rel="canonical" href="https://autowork.com.vn/terms" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://autowork.com.vn/terms" />
        <meta property="og:title" content="Điều Khoản Dịch Vụ | AutoWork" />
        <meta
          property="og:description"
          content="Xem đầy đủ điều khoản sử dụng AutoWork trước khi dùng dịch vụ."
        />
      </Helmet>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h1 className="text-3xl font-bold text-center text-blue-600 mb-8">
            ĐIỀU KHOẢN DỊCH VỤ - AUTOWORK
          </h1>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Giới thiệu và Chấp nhận Điều khoản
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Chào mừng bạn đến với AUTOWORK! Các Điều khoản Dịch vụ này ("Điều
              khoản") là một thỏa thuận pháp lý ràng buộc giữa bạn ("Người
              dùng", "bạn") và AUTOWORK ("Công ty", "chúng tôi"), quy định các
              quyền và nghĩa vụ của bạn khi sử dụng dịch vụ quản lý và tự động
              hóa nội dung fanpage Facebook của chúng tôi ("Dịch vụ").
            </p>
            <p className="text-gray-600 leading-relaxed mt-4">
              Bằng cách truy cập hoặc sử dụng Dịch vụ, bạn xác nhận rằng bạn đã
              đọc, hiểu và đồng ý bị ràng buộc bởi các Điều khoản này. Nếu bạn
              không đồng ý với bất kỳ phần nào của Điều khoản, bạn không được
              phép sử dụng Dịch vụ.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Mô tả Dịch vụ
            </h2>
            <p className="text-gray-600 mb-4">
              AUTOWORK là một công cụ dựa trên nền tảng web và ứng dụng trí tuệ
              nhân tạo (AI) cho phép người dùng tự động hóa việc tạo và đăng nội
              dung lên fanpage Facebook của họ. Các tính năng chính của Dịch vụ
              bao gồm, nhưng không giới hạn ở:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-4">
              <li>
                Tự động tạo nội dung (văn bản, hình ảnh) dựa trên các chủ đề và
                cài đặt do người dùng cung cấp
              </li>
              <li>Lên lịch đăng bài tự động lên fanpage</li>
              <li>Phân tích hiệu suất nội dung và cung cấp các báo cáo</li>
              <li>Quản lý nhiều fanpage (tùy thuộc vào gói dịch vụ)</li>
            </ul>
            <p className="text-gray-600 font-medium">
              Lưu ý quan trọng: AUTOWORK hoạt động thông qua API của Facebook và
              tuân thủ các chính sách của Facebook. Tuy nhiên, AUTOWORK không
              phải là sản phẩm của Facebook và không được Facebook bảo trợ,
              chứng thực hoặc liên kết.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Tài khoản Người dùng
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Đăng ký:</strong> Để sử dụng Dịch vụ, bạn có thể cần
                phải tạo một tài khoản AUTOWORK. Bạn phải cung cấp thông tin
                chính xác, đầy đủ và cập nhật khi đăng ký.
              </p>
              <p>
                <strong>Tính chính xác của thông tin:</strong> Bạn cam kết rằng
                tất cả thông tin bạn cung cấp cho AUTOWORK là chính xác, đầy đủ
                và không gây hiểu lầm.
              </p>
              <p>
                <strong>Bảo mật tài khoản:</strong> Bạn có trách nhiệm bảo mật
                thông tin đăng nhập tài khoản của mình. Bạn phải thông báo ngay
                cho AUTOWORK nếu phát hiện truy cập trái phép.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Trách nhiệm về nội dung do AI tạo ra
            </h2>
            <div className="text-gray-600 space-y-4">
              <p>
                <strong>Trách nhiệm pháp lý của người dùng:</strong> Bằng cách
                sử dụng Dịch vụ AUTOWORK, bạn hiểu và đồng ý rằng bạn hoàn toàn
                chịu trách nhiệm pháp lý và đạo đức đối với tất cả nội dung được
                tạo ra bởi AI và được đăng lên bất kỳ nền tảng mạng xã hội hoặc
                website nào thông qua tài khoản của bạn.
              </p>
              <p>
                <strong>Nội dung không phù hợp:</strong> Mặc dù hệ thống AI của
                chúng tôi được thiết kế để tạo ra nội dung phù hợp, nhưng
                AUTOWORK không thể đảm bảo 100% rằng tất cả nội dung được tạo ra
                sẽ phù hợp hoặc tuân thủ các quy định của tất cả các nền tảng.
                Bạn có trách nhiệm xem xét và chỉnh sửa nội dung trước khi đăng.
              </p>
              <p>
                <strong>Miễn trừ trách nhiệm:</strong> AUTOWORK sẽ không chịu
                trách nhiệm về bất kỳ hậu quả pháp lý, vi phạm bản quyền, khiếu
                nại về nội dung, hoặc bất kỳ hình thức thiệt hại nào phát sinh
                từ việc sử dụng nội dung do AI tạo ra thông qua Dịch vụ của
                chúng tôi.
              </p>
              <p>
                <strong>Trách nhiệm kiểm duyệt:</strong> Bạn phải thực hiện tất
                cả các biện pháp hợp lý để kiểm tra, kiểm duyệt và chỉnh sửa nội
                dung AI trước khi đăng công khai. Việc sử dụng tính năng tự động
                đăng không miễn trừ trách nhiệm của bạn đối với nội dung được
                đăng.
              </p>
              <p>
                <strong>Vi phạm quyền của bên thứ ba:</strong> Bạn phải đảm bảo
                rằng nội dung do AI tạo ra không vi phạm bất kỳ quyền sở hữu trí
                tuệ, quyền riêng tư, hoặc quyền khác của bên thứ ba. AUTOWORK
                không chịu trách nhiệm cho bất kỳ vi phạm nào.
              </p>
              <p>
                <strong>Bồi thường:</strong> Bạn đồng ý bồi thường và giữ cho
                AUTOWORK và các bên liên quan không bị tổn hại từ bất kỳ yêu cầu
                bồi thường, thiệt hại, trách nhiệm pháp lý, chi phí hoặc phí tổn
                (bao gồm cả phí luật sư hợp lý) phát sinh từ việc sử dụng nội
                dung do AI tạo ra của bạn.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              14. Thông tin liên hệ
            </h2>
            <div className="text-gray-600">
              <p className="mb-4">
                Nếu bạn có bất kỳ câu hỏi hoặc thắc mắc nào về các Điều khoản
                này, vui lòng liên hệ với chúng tôi:
              </p>
              <ul className="space-y-2">
                <li>
                  <strong>Email:</strong> autowork365@gmail.vn
                </li>
                <li>
                  <strong>Điện thoại:</strong> 0394.932.696
                </li>
                <li>
                  <strong>Địa chỉ:</strong> Hòa Phát, Cẩm Lệ, Đà Nẵng
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsScreen;
